module.exports = __webpack_public_path__ + "img/philip-morris-logo.323a5536.png";